import React from "react";

import Button from "../../atoms/button/button";
import Modal from "../../ui/modal/Modal";
import EquisClose from "../../atoms/icons/EquisClose";
import useLockScroll from "../../../hooks/useBlockScroll";

import "./ModalAge.scss";

interface ModalAgeProps {
    modalIsOpen: boolean;
    img?: string;
    title?: React.ReactNode;
    description: React.ReactNode;
    btnText?: string;
    onClose: () => void;
    onConfirm?: () => void;
}

const MAIN_CLASS = "m-modal-age";
const DEFAULT_ERROR_IMAGE =
    "https://images.ctfassets.net/203frbsx1z3n/1ReUpXs1rWXrp5H0Sa7nDH/9d8daa228206a1609b643a270fd8db37/error__4_.png";

const ModalAge = (props: ModalAgeProps) => {
    const {
        modalIsOpen: showAgeModal,
        img = DEFAULT_ERROR_IMAGE,
        title = "Lo sentimos, no cumples con la edad mínima",
        btnText = "Entendido",
        description,
        onClose,
        onConfirm,
    } = props;

    useLockScroll(showAgeModal);

    if (!showAgeModal) {
        return null;
    }

    return (
        <div className={`${MAIN_CLASS}`}>
            <Modal showModal={showAgeModal} onClose={onClose}>
               <div className={`${MAIN_CLASS}__close`} >
                  <EquisClose onClick={onClose} />
               </div>
                <div className={`${MAIN_CLASS}__container`}>
                    <img
                        className={`${MAIN_CLASS}__container__image`}
                        src={img}
                        alt="error"
                    />
                    <h1 className={`${MAIN_CLASS}__container__title`}>
                        {title}
                    </h1>
                    <p className={`${MAIN_CLASS}__container__description`}>
                        {description}
                    </p>
                    <Button
                        type="button"
                        text={btnText}
                        classname={`a-button__magenta`}
                        isDisabled={false}
                        onClickAction={onConfirm}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default ModalAge;
